import React,{useContext} from 'react'
import {themeContext} from '../../Context'

import './Education.css'
const Education = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    return <div className='education' style={{overflowX: 'auto'}}>
        <table className={darkMode ? 'table table_dark':'table table_light'}>
            <thead className={darkMode ?'thead_dark':'thead_light'}>
                <tr className={darkMode ? 'tr_dark':'tr_light'}>
                    <th> Degree </th>
                    <th> Department </th>
                    <th> Institute </th>
                    <th> Year </th>
                    <th> Percentage/CGPA </th>

                </tr>

            </thead>
            <tbody>
                <tr className={darkMode ? 'tr_dark':'tr_light'}>
                    <td className={darkMode?'td_dark':'td_light'}>B.Tech </td>
                    <td className={darkMode?'td_dark':'td_light'}> ECE </td>
                    <td className={darkMode?'td_dark':'td_light'}> CMR College of Engineering and Technology</td>
                    <td className={darkMode?'td_dark':'td_light'}> 2015-2019 </td>
                    <td className={darkMode?'td_dark':'td_light'}> 9.39 CGPA </td>

                </tr>
                <tr className={darkMode ? 'tr_dark':'tr_light'}>
                    <td className={darkMode?'td_dark':'td_light'}>Intermediate </td>
                    <td className={darkMode?'td_dark':'td_light'}> Maths,Physics,Chemistry </td>
                    <td className={darkMode?'td_dark':'td_light'}> S.V.S Junior College </td>
                    <td className={darkMode?'td_dark':'td_light'}> 2013-2015 </td>
                    <td className={darkMode?'td_dark':'td_light'}> 88.00% </td>
                </tr>
                <tr className={darkMode ? 'tr_dark':'tr_light'}>
                    <td className={darkMode?'td_dark':'td_light'}> SSC </td>
                    <td className={darkMode?'td_dark':'td_light'}> General </td>
                    <td className={darkMode?'td_dark':'td_light'}> Sputnik High Scool </td>
                    <td className={darkMode?'td_dark':'td_light'}> 2012-2013 </td>
                    <td className={darkMode?'td_dark':'td_light'}> 8.7 CGPA </td>
                </tr>
            </tbody>
        </table>
    </div>

}

export default Education